// extracted by mini-css-extract-plugin
module.exports = {"container":"kiosk-checkout_container__1AgzY","footer":"kiosk-checkout_footer__3z7Q5"};